import { render, staticRenderFns } from "./fly_data_two.vue?vue&type=template&id=ca02c5b0&scoped=true&"
import script from "./fly_data_two.vue?vue&type=script&lang=js&"
export * from "./fly_data_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca02c5b0",
  null
  
)

export default component.exports